import { SxProps } from '@mui/material'
import { flightInfoClasses } from './FlightInfo.data'

export interface FlightInfoStyles {
  flightInfo: SxProps
  airportWrapper: SxProps
  airportCode: SxProps
  flightTimings: SxProps
  divider: SxProps
  stopDetails: SxProps
  stopLabel: SxProps
  flightDuration: SxProps
  seeDetails: SxProps
  airportCodeLoader: SxProps
  flightTimingsLoader: SxProps
  stopLabelLoader: SxProps
  flightDurationLoader: SxProps
  seeDetailsLoader: SxProps
}

export const flightInfoStyles: FlightInfoStyles = {
  flightInfo: {
    gap: { xs: 3, md: 1, lg: 2 },
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: { lg: 350, xl: 400 },
    justifyContent: { md: 'space-evenly' },
    [`&.${flightInfoClasses.smallFonts}`]: {
      gap: { xs: 2, md: 1, lg: 2 },
      justifyContent: 'space-between',
      width: 'auto',
    },
  },
  airportWrapper: {
    width: { lg: 100, xl: 130 },
    [`.${flightInfoClasses.smallFonts} &`]: {
      width: 'auto',
    },
  },
  airportCode: {
    typography: { xs: 'textMdSemibold', md: 'textXlSemibold' },
    color: 'text.primary',
    mb: 0.5,
    textAlign: 'center',
    [`.${flightInfoClasses.smallFonts} &`]: { typography: 'textSmSemibold' },
  },
  flightTimings: {
    typography: 'textSmMedium',
    color: 'text.secondary700',
    textAlign: 'center',
    [`.${flightInfoClasses.smallFonts} &`]: { typography: 'textXsMedium' },
  },
  flightDuration: { typography: 'textXsMedium', color: 'text.secondary700', textAlign: 'center' },
  seeDetails: { typography: 'textXsSemibold', color: 'text.hyperLink', textAlign: 'center' },
  divider: { height: '1px', width: '24px', alignSelf: 'center' },
  stopDetails: { minWidth: 75, textAlign: 'center' },
  stopLabel: {
    typography: { xs: 'textSmSemibold', md: 'textMdSemibold' },
    color: 'text.primary',
    mb: 0.5,
    [`.${flightInfoClasses.smallFonts} &`]: { typography: 'textXsSemibold' },
  },
  airportCodeLoader: {
    width: 40,
    height: 30,
    mx: 'auto',
  },
  flightTimingsLoader: {
    width: 60,
    height: 20,
    mx: 'auto',
  },
  stopLabelLoader: {
    width: 60,
    height: 24,
    mx: 'auto',
  },
  flightDurationLoader: {
    width: 60,
    height: 18,
    mx: 'auto',
  },
  seeDetailsLoader: {
    width: 60,
    height: 18,
    mx: 'auto',
  },
}
